module.exports = "/_next/static/images/co-d1a61f9499bd5d5ab4ffa6dcb3ce5c09.svg";